import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7 border-b" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "p-7" }
const _hoisted_7 = { class: "col-span-12" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import PageLoader from '@/components/PageLoader.vue';
import AdminData from '@/classes/AdminData';
import AuthService from '@/classes/AuthService';
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';



export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const route = useRoute();
const getLoggedAdmin = computed(() => AdminData.getAdmin()) 

// DATA
const loader      = ref(false)
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref();
const adminId     = ref(route.params.id as unknown as string);

const errors = ref([]);
const profilePayload = ref({
    first_name   : null,
    last_name    : null,
    email        : null,
    mobile_number: null
})

const passwordPayload = ref({
    email                : getLoggedAdmin.value.email,
    current_password     : null,
    password             : null,
    password_confirmation: null
})

const errorResponse = (err: any) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}


const updateAdmin = async () => {
  loader.value = true;

  try {
    await AdminData.updateAdmin(adminId.value, profilePayload.value);
    loader.value      = false;
    showSuccess.value = true;

    setTimeout(() => {
      window.location.replace(`/profile/${adminId.value}`);
    }, 2000);

  } catch (error: any) {
    loader.value    = false;
    showError.value = true;
    errorMsg.value  = error.response?.data?.message;

    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
    }
    errorResponse(error);
  }
};

const changePassword = async () => {
  loader.value = true;

  try {
    await AdminData.tokenlessChangePassword(passwordPayload.value);
    loader.value      = false;
    showSuccess.value = true;

    setTimeout(() => {
      window.location.replace(`/profile/${adminId.value}`);
    }, 2000);

  } catch (error: any) {
    loader.value    = false;
    showError.value = true;
    errorMsg.value  = error.response?.data?.message;

    if(!errorMsg.value) {
        errorMsg.value  = error.response?.data?.error;
    }

    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
    }
  }
};

const validateAdmin = () => {
    if(getLoggedAdmin.value.id != adminId.value) {
        showError.value = true;
        errorMsg.value  = "Unauthorized access.";
    } else {
        fetchAdmin();
    }
}
const fetchAdmin = async() => {
    try {
        const response = await AdminData.editAdmin(adminId.value);
        Object.assign(profilePayload.value, response.data.admin);
    } catch (error: any) {
        showError.value = true;
        errorMsg.value = error.response.data.message;
    } finally {
        loader.value = false;
    }
}

onMounted(() => { validateAdmin() })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Profile" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (getLoggedAdmin.value.id == adminId.value)
          ? (_openBlock(), _createBlock(FormSection, { key: 0 }, {
              title: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Profile Information ", -1)
              ]))]),
              description: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" Relevant data and other details ", -1)
              ]))]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(TextInput, {
                    modelValue: profilePayload.value.first_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profilePayload.value.first_name) = $event)),
                    id: "first_name",
                    name: "first_name",
                    label: "First Name",
                    placeholder: "First Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TextInput, {
                    modelValue: profilePayload.value.last_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profilePayload.value.last_name) = $event)),
                    id: "last_name",
                    name: "last_name",
                    label: "Last Name",
                    placeholder: "Last Name"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(TextInput, {
                    modelValue: profilePayload.value.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profilePayload.value.email) = $event)),
                    id: "email",
                    name: "email",
                    label: "Email Address",
                    placeholder: "Email Address"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(TextInput, {
                    modelValue: profilePayload.value.mobile_number,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((profilePayload.value.mobile_number) = $event)),
                    id: "mobile_number",
                    name: "mobile_number",
                    label: "Mobile Number",
                    placeholder: "Mobile Number",
                    addOnLeft: "",
                    addOnText: "+63",
                    maxlength: 10,
                    oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              actions: _withCtx(() => [
                (_ctx.$hasPermission('update-account-profile'))
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (updateAdmin()))
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode(" Save Changes ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (getLoggedAdmin.value.id == adminId.value)
          ? (_openBlock(), _createBlock(FormSection, { key: 0 }, {
              title: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode(" Security Information ", -1)
              ]))]),
              description: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" Relevant data and other details ", -1)
              ]))]),
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(PasswordInput, {
                    modelValue: passwordPayload.value.current_password,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordPayload.value.current_password) = $event)),
                    id: "current_password",
                    name: "current_password",
                    label: "Current Password",
                    placeholder: "Current Password"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(PasswordInput, {
                    modelValue: passwordPayload.value.password,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordPayload.value.password) = $event)),
                    name: "password",
                    id: "password",
                    label: "New Password",
                    placeholder: "New Password"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(PasswordInput, {
                    modelValue: passwordPayload.value.password_confirmation,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((passwordPayload.value.password_confirmation) = $event)),
                    id: "confirmPassword",
                    name: "confirmPassword",
                    label: "Confirm New Password",
                    placeholder: "Confirm New Password"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              actions: _withCtx(() => [
                _createVNode(ButtonComponent, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (changePassword()))
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" Save Changes ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[10] || (_cache[10] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Profile",
        content: "Profile Updated Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[11] || (_cache[11] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[12] || (_cache[12] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})